import {FaRegPlayCircle } from "react-icons/fa";

const PlayIcon = () => {
    return (<FaRegPlayCircle
        background-color="#012501"
        color="#01dd01"
        size="2em"
        border="10px"
        
        />)

}

export default PlayIcon;